        function detectmob() {
         if( navigator.userAgent.match(/Android/i)
         || navigator.userAgent.match(/webOS/i)
         || navigator.userAgent.match(/iPhone/i)
         || navigator.userAgent.match(/iPad/i)
         || navigator.userAgent.match(/iPod/i)
         || navigator.userAgent.match(/BlackBerry/i)
         || navigator.userAgent.match(/Windows Phone/i)
         ){
            return true;
          }
         else {
            return false;
          }
        }

        var is_mobile = detectmob();



        (function() {
          var imageReveal,
              is_mobile = detectmob(),
              startevent,
              leaveevent,
              moveevent,
            bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

            if( is_mobile == true){
              startevent = 'touchstart';
              leaveevent = 'touchleave';
              moveevent = 'touchmove';
            }else{
              startevent = 'mouseenter';
              leaveevent = 'mouseleave';
              moveevent = 'mousemove';
            }

          imageReveal = (function() {
            function imageReveal(el) {
              this.el = el;
              this.moveSplit = bind(this.moveSplit, this);
              this.calculateSplit = bind(this.calculateSplit, this);
              // this.resetReveal = bind(this.resetReveal, this);
              this.startReveal = bind(this.startReveal, this);
              this._bindEvents = bind(this._bindEvents, this);
              this.overSlide = this.el.find('.js-over-slide');
              this.overImage = this.el.find('.js-over-image');
              this.divider = this.el.find('.js-divider');
              // console.log(this.el);
              this._bindEvents();
              this.resetReveal();
            }

            imageReveal.prototype._bindEvents = function() {
              this.el.on(startevent, this.startReveal);
              // return this.el.on(leaveevent, this.resetReveal);
            };

            imageReveal.prototype.startReveal = function() {
              // console.log('start reveal');
              return this.el.on(moveevent, this.calculateSplit);
            };

            imageReveal.prototype.resetReveal = function() {
              var elMiddle;
              // console.log('reset');
              this.el.off(moveevent, this.calculateSplit);
              elMiddle = this.el.width() / 2;
              return this.moveSplit(elMiddle);
            };

            imageReveal.prototype.calculateSplit = function(e) {
              var elOffset;
              elOffset = this.el.offset().left;
              if(is_mobile == true){
                return this.moveSplit(e.originalEvent.touches[0].pageX - elOffset);
              }else{
                return this.moveSplit(e.pageX - elOffset);
              }
            };

            imageReveal.prototype.moveSplit = function(offset) {
              if (offset < 0) {
                offset = 0;
              }
              // console.log(offset);
              this.overSlide.css('transform', 'translateX(' + offset + 'px)');
              this.overImage.css('transform', 'translateX(-' + offset + 'px)');
              return this.divider.css('transform', 'translateX(' + offset + 'px)');
            };

            return imageReveal;

          })();

          window.imageReveal = imageReveal;

          $(function() {
            $('.js-image-reveal').each(function(){
              return new imageReveal( $(this) ) ;
            });
          });

        }).call(this);


$(document).ready(function(){
  $('.arc-slick').slick({
    slidesToShow: 1,
    asNavFor: '.arc-slick-nav',
    swipeToSlide : true,
     adaptiveHeight: true
  });
  $('.arc-slick-nav').slick({
    slidesToShow: 3,
    asNavFor: '.arc-slick',
    focusOnSelect: true,
    swipeToSlide : true
  });
  

//     $('iframe.instagram-media').on('load',function(){
//       console.log($(this));
//       var correctHeight = $(this)[0].getAttribute("height");
//       $(this).height(correctHeight);
//       console.log(correctHeight);
//       console.log($(this)[0].attributes.height);
//     })

  
  function getHeightOfIframe(){
    $( 'iframe.instagram-media' ).each(function( index ) {
      var correctHeightTwo = $(this)[0].getAttribute("height");
      $(this).height(correctHeightTwo);
      console.log($(this));
      console.log($(this)[0].height);
      console.log(correctHeightTwo);
      console.log($(this)[0].attributes[6].value);
    });
  }
  setTimeout(getHeightOfIframe, 6000);
  
  
  $('a[href="https://mailchi.mp/arcscissors/shear-giveaway"] ').attr('target','_blank')
});
		